// Product card colour circles (snippets/card-swatches.liquid): clicking one shows that colour's photo
// on the card and points the card link at that colour.
if (!window.__luunaCardSwatches) {
  window.__luunaCardSwatches = true;
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();
    const group = swatch.closest('[data-card-swatches]');
    const card = group.closest('article') || group.closest('li');
    const link = card?.querySelector('a[href] img')?.closest('a');
    if (!link) return;
    group.querySelectorAll('[data-card-swatch]').forEach((b) => b.setAttribute('aria-pressed', String(b === swatch)));

    const img = link.querySelector('img');
    if (img && swatch.dataset.src) {
      img.removeAttribute('loading');
      if (swatch.dataset.srcset) img.srcset = swatch.dataset.srcset;
      img.src = swatch.dataset.src;
      // Keep the same space above the model's head for the new colour's photo (collection and search cards).
      if ('pos' in swatch.dataset) img.style.objectPosition = swatch.dataset.pos;
      img.alt = `${link.getAttribute('aria-label') || ''} – ${swatch.title}`;
      // The hover photo belongs to the first colour, so stop showing it once another colour is picked.
      link.querySelectorAll('img').forEach((other) => { if (other !== img) other.style.display = 'none'; });
    }
    if (swatch.dataset.url) {
      card.querySelectorAll('a[href]').forEach((a) => {
        if (a.closest('[data-card-swatches]')) return;
        a.href = swatch.dataset.url;
      });
    }
  });
}
